import "./shared-storage.less";
import { IComponentOptions, IComponentController, IOnChangesObject } from 'angular';
import { IInstanceSettings } from "../../typings/board/Models";

import './shared-storage.less';
import { Description } from "../capsule-manager-guide/capsuleManagerGuide.component";

export const SHARED_STORAGE_COMPONENT = "sharedStorageComponent";

class SharedStorageComponentController implements IComponentController {

    private settings: IInstanceSettings;
    private descriptions : Description[];

    //labels
    get sasUriLabel(): string { return "Shared Access Signature (SAS) URI:"; }

    get sasUri(): string { return this.settings.sasKey; }
    
    static $inject = ["$mdToast"];
    constructor(private $mdToast: ng.material.IToastService) {
        this.descriptions = [];
        // tslint:disable-next-line:max-line-length
        this.descriptions.push(new Description("Shared storage", "Exchange files across Test or Prod instances in a secure and fast way using AZCOPY command tool or the Storage Explorer GUI from Microsoft. AZCOPY will be displayed as a shared drive on your instances to exchange files."));
     
     }

    private showCopyMsg() {
        this.$mdToast.show(this.$mdToast.simple().textContent("Copied to clipboard!").position("top right"));
    }

}

export const sharedStorageComponentOptions: IComponentOptions = {
    controller: SharedStorageComponentController,
    template: require("./shared-storage.html"),
    bindings: {
        settings: "<"
    }
};


// WEBPACK FOOTER //
// ./app/shared-storage/shared-storage.component.ts